// extracted by mini-css-extract-plugin
export default {"input":"WidgetPhone_input__FbQvE"};